import { render, staticRenderFns } from "./SearchBarFilterStandAlone.vue?vue&type=template&id=0fc18974&scoped=true"
import script from "./SearchBarFilterStandAlone.vue?vue&type=script&lang=js"
export * from "./SearchBarFilterStandAlone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc18974",
  null
  
)

export default component.exports